import React, { useContext, useEffect, useState } from "react";
import "./../genericModels.css";
import { rangeCarActions } from "../../service/rangecar.actions";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { DataGrid } from "@mui/x-data-grid";
import { CarRangeFilterAndSearch } from "./CarRangeFilterAndSearch";
import { CarRangeMainTitle } from "./CarRangeMainTitle";
import FileSaver from "file-saver";
import { GlobalContext } from  "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import CustomLoader from "../../../../util/component/CustomLoader";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { IServerSideGetRowsParams } from "ag-grid-community";
import { Card, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ContextOperation } from "../../context/OperationContext";
import SectionHeader from "../../../../util/component/SectionHeader";
import AgGridOperationTable from "../common/AgGridOperationTable";

export default function CarRangeTable() {
  const { t } = useTranslation(["operation"]);
  const userRangeCar = rangeCarActions();
  const { dispatchGlobalData } = useContext(GlobalContext);
  let pageSize: number=10;

  const [length, setLength] = useState<number>(0);
  const [resetFormValue, setResetFormValue] = useState<boolean>(false);
  const [loading, setIsLoading] = useState<boolean>(false);
  const [gridApi, setGridApi] = useState<any>(null);

  const [dataFormSearchFieldCarRange, setDataFormSearchFieldCarRange] =
    useState<any>({
      code: "",
      descr: "",
    });
    const {tenant} = useContext(ContextOperation);
  const [rowData, setRowData] = useState<any>([]);
  const columnDefs :any =[
    { field: "descr", headerName: t("carRange.description"), flex: 1 },
    { field: "code", headerName: t("carRange.code"), flex: 1 },
  ];

  function resetFormTextCarRange() {
    setDataFormSearchFieldCarRange({ code: "", descr: "" });
    setResetFormValue(!resetFormValue);
  }

  const exportDataCarRange = async () => {
    setIsLoading(true);
    let descr = !!dataFormSearchFieldCarRange.descr? dataFormSearchFieldCarRange.descr.trim() : null;
    let code = !!dataFormSearchFieldCarRange.code? dataFormSearchFieldCarRange.code.trim() : null;
    userRangeCar
      .exportDataCarRange(
        tenant,
        code,
        descr
      )
      .then((response: any) => {
        setIsLoading(false);
        const filename =
          response.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, filename);
      });
  };
 

  const getCarRangeQueryParams = (
  ) => {
    let descr = !!dataFormSearchFieldCarRange.descr? dataFormSearchFieldCarRange.descr.trim() : null;
    let code = !!dataFormSearchFieldCarRange.code? dataFormSearchFieldCarRange.code.trim() : null;
    setIsLoading(true);
    return {
      getRows: async (params: IServerSideGetRowsParams) => {
        const startRow = params.request.startRow ? params.request.startRow : 0;
        const endRow = params.request.endRow;
        
        if (endRow !== null && endRow !== undefined && startRow !== null && startRow !== undefined) {
          pageSize = endRow - startRow;
        }
        const pageNumber = startRow / pageSize
    userRangeCar
      .getCarRangeQueryParams(pageNumber, pageSize,tenant, code, descr)
      .then((response: any) => {
        params.successCallback(
          managerData(response),
          response.data.totalElements
          
        );
        
        setLength(response.data.totalElements)
 
        setIsLoading(false);
      })
      .catch((error: any) => {
        if (error.response) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
                snackbar: {
                    message:error.response.data.error,
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                }
            }
        });
          setIsLoading(false);
        } else if (error.request) {
          const messageForTimeout = t("networkErrorMessage");
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
                snackbar: {
                    message:messageForTimeout,
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                }
            }
        });
        setIsLoading(false);
      }else{
        setIsLoading(false);
      }
        
      });
    }
  }
  };
  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  function managerData(response: any) {
      let rows: any[] = [];
      response.data.content.forEach((element: any) => {
        let row = {
          code: element.code,
          descr: element.descr,
          id: element.id,
        };
        rows.push(row);
      });
      return rows;
    
  }


  useEffect(() => {
    if (gridApi) {
      gridApi.setServerSideDatasource(
    getCarRangeQueryParams());
    }
  }, [gridApi,resetFormValue]);

  return (
    <>
        <SectionHeader
            title={t("carRange.titleFirst") + " " + t("carRange.titleSecond")}
        />
      <CarRangeFilterAndSearch
        dataFormSearchFieldCarRange={dataFormSearchFieldCarRange}
        setDataFormSearchFieldCarRange={setDataFormSearchFieldCarRange}
        resetFormTextCarRange={resetFormTextCarRange}
        resetFormValue ={resetFormValue}
        setResetFormValue ={setResetFormValue}
        
      />

      <Box className="carBrandOuterTableBox">
      <Box>
        <Card >
       
        
            <Box minHeight={46} pr={1} display="flex" justifyContent={'flex-end'} alignItems="center" >
             <Tooltip  title={t("tooltipTitle.download")}>
            <IconButton color="accent" disabled ={length === 0 ?true:false} onClick ={exportDataCarRange}>
                <FileDownloadIcon/>
               </IconButton>
               </Tooltip>
          </Box>
         
        
        </Card>
        </Box>
       
        <Box>  
          <AgGridOperationTable
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            cacheBlockSize={pageSize}
            serverSideInfiniteScroll={true}
            rowModelType={"serverSide"}
            totalElements={length}
		/>  


          {loading && <CustomLoader loading={loading} />}
        </Box>
        </Box>
      
    </>
  );
}
